import { TreeDataNode } from '@livv/models';
import { FC } from 'react';
import CustomTreeItem from '@components/Tree/CustomTreeItem';

interface TreeItemsProps {
    generateLabel?: (title: string, path: string) => JSX.Element;
    nodes: TreeDataNode[];
    onNodeSelection?: (path: string) => void;
    parentPath?: string;
}

const TreeItems: FC<TreeItemsProps> = ({ generateLabel, nodes, onNodeSelection, parentPath }) => {
    if (!nodes.length) {
        return null;
    }

    return (
        <>
            {nodes.map((node) => {
                const { children, id, title } = node;
                const path = parentPath ? `${parentPath}/${id}` : id;

                return (
                    <CustomTreeItem
                        key={id}
                        data-test-id={`tree-item-node-${id}`}
                        itemId={id}
                        label={generateLabel ? generateLabel(title, path) : title}
                        onClick={() => onNodeSelection && onNodeSelection(path)}
                    >
                        {Boolean(children?.length) && (
                            <TreeItems
                                generateLabel={generateLabel}
                                nodes={children || []}
                                onNodeSelection={onNodeSelection}
                                parentPath={path}
                            />
                        )}
                    </CustomTreeItem>
                );
            })}
        </>
    );
};

export default TreeItems;
